import axiosInstance from '../../../axiosInstance';
import apiEndpoints from '../../../api';
import { notify } from '../../../../utils/notification';

export const getEmployeesListReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_EMPLOYEES_LIST_API;
    const params = {
        society_id: action.data?.societyId,
        page: action.data?.page || 1,
        limit: action.data?.limit || 10,
        search: action.data?.search || undefined,
        // The API filters on is_active (1/0); the page's dropdown speaks
        // active/inactive. Sending `status` was rejected outright:
        // 'query: "status" is not allowed'.
        is_active: action.data?.status === 'active' ? 1
            : action.data?.status === 'inactive' ? 0
            : undefined,
    };
    return axiosInstance.get(url, { params })
        .then(res => res)
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Something went wrong');
            return err;
        });
};

export const getEmployeeDetailsReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_EMPLOYEE_DETAILS_API.replace(':id', action.data.id);
    return axiosInstance.get(url, {
        params: { society_id: action.data?.societyId },
    })
        .then(res => res)
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Something went wrong');
            return err;
        });
};

export const createEmployeeReq = (action) => {
    const url = apiEndpoints.SOCIETY_CREATE_EMPLOYEE_API;
    const { onSuccess, onError, ...payload } = action.data || {};
    return axiosInstance.post(url, payload)
        .then(res => {
            if (res?.success) notify('success', res.message || 'Employee created successfully');
            return res;
        })
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Something went wrong');
            return err;
        });
};

export const updateEmployeeReq = (action) => {
    const url = apiEndpoints.SOCIETY_UPDATE_EMPLOYEE_API.replace(':id', action.data.id);
    const { id, onSuccess, onError, ...payload } = action.data || {};
    return axiosInstance.put(url, payload)
        .then(res => {
            if (res?.success) notify('success', res.message || 'Employee updated successfully');
            return res;
        })
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Something went wrong');
            return err;
        });
};

export const deleteEmployeeReq = (action) => {
    const url = apiEndpoints.SOCIETY_DELETE_EMPLOYEE_API.replace(':id', action.data.id);
    return axiosInstance.delete(url)
        .then(res => {
            if (res?.success) notify('success', res.message || 'Employee deleted successfully');
            return res;
        })
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Something went wrong');
            return err;
        });
};

export const getEmployeeTypesReq = (action) => {
    return axiosInstance.get(apiEndpoints.SOCIETY_GET_EMPLOYEE_TYPES_API)
        .then(res => res)
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Failed to load employee types');
            return err;
        });
};

export const getCountriesDropdownReq = () => {
    return axiosInstance.get(apiEndpoints.SOCIETY_GET_COUNTRIES_DROPDOWN_API)
        .then(res => res)
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Failed to load countries');
            return err;
        });
};

export const getEmployeeAuditLogReq = (action) => {
    return axiosInstance.get(apiEndpoints.SOCIETY_GET_EMPLOYEE_AUDIT_LOG_API, {
        params: {
            society_id: action.data?.societyId,
            employee_id: action.data?.id,
        },
    })
        .then(res => res)
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Failed to load audit log');
            return err;
        });
};

export const searchEmployeeByEmailReq = (action) => {
    return axiosInstance.get(apiEndpoints.SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_API, {
        params: {
            email: action.data?.email,
            society_id: action.data?.societyId,
        },
    })
        .then(res => res)
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Employee not found');
            return err;
        });
};

export const linkExistingEmployeeReq = (action) => {
    const { onSuccess, onError, ...payload } = action.data || {};
    return axiosInstance.post(apiEndpoints.SOCIETY_LINK_EXISTING_EMPLOYEE_API, payload)
        .then(res => {
            if (res?.success) notify('success', res.message || 'Employee added to society');
            return res;
        })
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Failed to link employee');
            return err;
        });
};

export const getUsernamesDropdownReq = (action) => {
    // Employee screens pass sourceType: 'EMPLOYEE'. They then read the staff
    // roster (employees that have a login) instead of every user in the society,
    // which listed flat owners and tenants in the Employee Login Report picker.
    const isStaffOnly = action.data?.sourceType === 'EMPLOYEE';
    const url = isStaffOnly
        ? apiEndpoints.SOCIETY_GET_EMPLOYEE_LOGIN_REPORT_USERS_API
        : apiEndpoints.SOCIETY_GET_USERNAMES_DROPDOWN_API;
    return axiosInstance.get(url, {
        params: { society_id: action.data?.societyId },
    })
        .then(res => res)
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Failed to load usernames');
            return err;
        });
};

export const getEmployeesDropdownReq = (action) => {
    return axiosInstance.get(apiEndpoints.SOCIETY_GET_EMPLOYEES_DROPDOWN_API, {
        params: {
            society_id: action.data?.societyId,
            search: action.data?.search || undefined,
        },
    })
        .then(res => res)
        .catch((err) => {
            notify('error', err?.response?.data?.message || 'Failed to load employees');
            return err;
        });
};
